import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container hero-layout">
            <div className="intro-text">
              <span className="eyebrow"><span className="eyebrow-dot"></span> MAITRI TECH SOLUTIONS</span>
              <h1>
                Digital solutions,
                <span> designed for impact.</span>
              </h1>
              <p>
                {props.data
                  ? props.data.paragraph
                  : "Building thoughtful technology for ambitious businesses."}
              </p>
              <div className="hero-actions">
                <a href="#contact" className="btn btn-custom page-scroll">
                  Discuss your project <i className="fa fa-arrow-right" aria-hidden="true"></i>
                </a>
                <a href="#services" className="hero-secondary page-scroll">
                  Explore services <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                </a>
              </div>
              <div className="hero-note">
                <span className="hero-note-line"></span>
                <span>From first idea to launch and beyond</span>
              </div>
            </div>
            <div className="hero-visual" aria-hidden="true">
              <div className="hero-orbit orbit-one"></div>
              <div className="hero-orbit orbit-two"></div>
              <div className="hero-glass-panel">
                <div className="panel-topline">
                  <span className="panel-window-dots"><i></i><i></i><i></i></span>
                  <span>Digital ecosystem</span>
                  <i className="fa fa-ellipsis-h"></i>
                </div>
                <div className="panel-content">
                  <div className="panel-label">CONNECTED TECHNOLOGY</div>
                  <div className="panel-headline">Ideas into<br /><strong>experiences.</strong></div>
                  <div className="panel-connection">
                    <span className="connection-node"><i className="fa fa-mobile"></i></span>
                    <span className="connection-line"></span>
                    <span className="connection-node connection-node-main"><img src="/logo.png" alt="" /></span>
                    <span className="connection-line"></span>
                    <span className="connection-node"><i className="fa fa-cloud"></i></span>
                  </div>
                  <div className="panel-footer">
                    <span>Mobile</span><span>Made to work together</span><span>Cloud</span>
                  </div>
                </div>
              </div>
              <div className="hero-float-tag"><span></span> Thoughtful by design</div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
